<template>
  <v-footer
    padless
    class="caption app-footer"
  >
    <v-container
      class="text-center pa-0 footer-content"
      fluid
    >
      <div>
        <span>{{ t('common.footer.text1') }} {{ new Date().getFullYear() }} {{ t('common.footer.text2') }}</span>
        <span>&nbsp;|&nbsp;</span>
        <button
          type="button"
          class="text-capitalize"
          @click.stop.prevent="$store.dispatch('SET_DIALOG_CONTENT', { component: 'termsOfUse' })"
        >
          {{ t('common.footer.termsOfUse') }}</button>
        <span>&nbsp;|&nbsp;</span>
        <button
          type="button"
          class="text-capitalize"
          @click.stop.prevent="$store.dispatch('SET_DIALOG_CONTENT', { component: 'privacy' })"
        >
          {{ t('common.footer.privacyPolicy') }} </button>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import lang from '@/mixins/lang';

export default {
  name: 'Footer',
  mixins: [lang],
};
</script>

<style scoped>
.app-footer {
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
}

.footer-content {
  line-height: 32px;
}

.text-capitalize {
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
</style>
